import { createRouteRef, createExternalRouteRef } from '@backstage/core-plugin-api';

const rootRouteRef = createRouteRef({
  id: "environment-explorer"
});
createExternalRouteRef({
  id: "create-component",
  optional: true
});
createExternalRouteRef({
  id: "view-techdoc",
  optional: true,
  params: ["namespace", "kind", "name"]
});
createExternalRouteRef({
  id: "create-from-template",
  optional: true,
  params: ["namespace", "templateName"]
});

export { rootRouteRef };
//# sourceMappingURL=routes.esm.js.map
